import { Typography } from '@material-ui/core';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const FinCen: React.FC<PropertyOrderInsightsProps> = ({ property, isPdf }) => {
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.FinCen,
  );

  const parentRiskSeverity = getParentSeverity(property.risks, RiskCategory.FinCen);

  const classes = orderInsightStyles();

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon isPdf={isPdf} riskSeverity={parentRiskSeverity} />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              FinCEN:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          {parentRiskSeverity === 'Success' && (
            <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
              FinCEN reporting not required.
            </Typography>
          )}
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
            className={parentRiskSeverity !== 'Success' ? classes.removeFirstAlertMargin : ''}
          />
        </div>
      </div>
    </div>
  );
};

export default FinCen;
